import { render, staticRenderFns } from "./watchBroadcast.vue?vue&type=template&id=669d7117&scoped=true"
import script from "./watchBroadcast.vue?vue&type=script&lang=js"
export * from "./watchBroadcast.vue?vue&type=script&lang=js"
import style0 from "./watchBroadcast.vue?vue&type=style&index=0&id=669d7117&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669d7117",
  null
  
)

export default component.exports